import React from "react";
import { useNavigate } from "react-router-dom";

const Footer2 = () => {
  const navigate = useNavigate();
  const linkStyle = { color: "inherit", textDecoration: "none", cursor: "pointer" };
  return (
    <footer className="oot-footer">
      <div className="oot-footer-inner">
        <div>
          <div className="brand"><span className="oot-brand-dot" />Oot<span>lob</span></div>
          <p>Ootlob is an online marketplace bringing trusted local stores together — appliances,
             home, kids and more — delivered across Lebanon.</p>
        </div>
        <div>
          <h4>Shop</h4>
          <ul>
            <li onClick={() => navigate("/Category")}>All Products</li>
            <li onClick={() => navigate("/Category")}>Categories</li>
            <li onClick={() => navigate("/Category")}>Offers</li>
            <li onClick={() => navigate("/MyOrders")}>My Orders</li>
          </ul>
        </div>
        <div>
          <h4>Company</h4>
          <ul>
            <li><a href="/about" style={linkStyle}>About Us</a></li>
            <li><a href="/contact" style={linkStyle}>Contact</a></li>
            <li><a href="/privacy" style={linkStyle}>Privacy Policy</a></li>
            <li><a href="/terms" style={linkStyle}>Terms &amp; Conditions</a></li>
          </ul>
        </div>
        <div>
          <h4>Get in touch</h4>
          <ul>
            <li>Reach us by phone or message</li>
            <li>Phone: +961 81 696 624</li>
            <li><a href="mailto:support@ootlob.com" style={linkStyle}>Email: support@ootlob.com</a></li>
          </ul>
        </div>
      </div>
      <div className="oot-footer-bottom"><div>© {new Date().getFullYear()} Ootlob. All rights reserved.</div></div>
    </footer>
  );
};

export default Footer2;
